module.exports = __webpack_public_path__ + "static/media/IMG_9474.29694ff6.jpg";